import React, { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { useApp } from "../context/AppContext";
import { CONTACT_TEXT, waUrl } from "../waHelper";

export default function WhatsAppWidget() {
  const { settings } = useApp();
  const [open, setOpen] = useState(false);
  const waLink = waUrl(settings.whatsapp, CONTACT_TEXT);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {open && (
        <div data-testid="whatsapp-widget-panel" className="glass rounded-2xl p-5 w-72 max-w-[calc(100vw-3rem)] animate-fade-up shadow-2xl">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full orange-gradient grid place-items-center">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="font-semibold text-sm">SmartLogistics</p>
              <p className="text-xs text-green-400">● Online now</p>
            </div>
          </div>
          <p className="text-sm text-neutral-700 mb-4">
            Need to send a parcel or get a quote? Chat with our team on WhatsApp.
          </p>
          <a data-testid="whatsapp-widget-chat-link" href={waLink} target="_blank" rel="noreferrer"
            className="orange-gradient text-white text-sm font-semibold rounded-lg py-2.5 flex items-center justify-center gap-2 hover:opacity-90 transition">
            <MessageCircle className="w-4 h-4" /> Start Chat
          </a>
          <a data-testid="whatsapp-widget-number-link" href={waLink} target="_blank" rel="noreferrer"
            className="mt-2 border border-neutral-300 text-neutral-800 text-sm rounded-lg py-2.5 flex items-center justify-center gap-2 hover:bg-black/[0.04] transition">
            <MessageCircle className="w-4 h-4 text-orange-500" /> +{settings.whatsapp}
          </a>
        </div>
      )}
      <button data-testid="whatsapp-widget-toggle" aria-label={open ? "Close WhatsApp" : "WhatsApp Us"} aria-expanded={open} onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full orange-gradient orange-glow grid place-items-center text-white shadow-xl hover:scale-105 transition-transform">
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-7 h-7" />}
      </button>
    </div>
  );
}
